import axios from "axios";

export const srcPath = (following: string = ""): string => {
  return `${process.env.PUBLIC_URL}/assets/${following}`;
};

export const get = async (path: string) => {
  const url = `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PATH}${path}`;
  const params = {
    timestamp: Date.now().toString(),
  };
  return await axios.get(url, { params });
};
